import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import { ContactsBook3Fill } from '../../../../components/icons/Icons.js';

const Contact = ({ data }) => {
    return <Row>
        <Col sm="6" className='mt-4'>
            <div className="employee-app">
                <Card className="employee-card position-relative overflow-hidden">
                    <Card.Header className="d-flex align-items-center justify-content-start gap-2">
                        <div className="employee-bullet">
                            <ContactsBook3Fill class_name="text-purple" />
                        </div>
                        <div className="employee-title text-purple">Contacts Details</div>
                    </Card.Header>
                    <Card.Body className="">
                        <Row className="gy-4">
                            <Col md={6}>
                                <div className="d-flex flex-column gap-2">
                                    <div>
                                        <div className="employee-label">Mobile:</div>
                                        <div className="employee-value">{data.mobile_number || "-"}</div>
                                    </div>
                                    <div>
                                        <div className="employee-label">Personal Email:</div>
                                        <div className="employee-value">{data.personal_email || "-"}</div>
                                    </div>


                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="d-flex flex-column gap-2">
                                    <div>
                                        <div className="employee-label">Official Email:</div>
                                        <div className="employee-value">{data.official_email || "-"}</div>
                                    </div>

                                    <div>
                                        <div className="employee-label">Address:</div>
                                        <div className="employee-value">{data.addressDetails?.address || "-"}</div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

            </div>
        </Col>

        {/* <Col sm="6" className='mt-4'>
            <div className="employee-app">
                <Card className="employee-card position-relative overflow-hidden">
                    <Card.Header className="d-flex align-items-center justify-content-start gap-2">
                        <div className="employee-bullet">
                            <Clock />
                        </div>
                        <div className="employee-title text-purple">Work Details</div>
                    </Card.Header>
                    <Card.Body className="">
                        <Row className="gy-4">
                            <Col md={6}>
                                <div className="d-flex flex-column gap-2">
                                    <div>
                                        <div className="employee-label">Shift:</div>
                                        <div className="employee-value">{data.shift || "-"}</div>
                                    </div>
                                    <div>
                                        <div className="employee-label">DOJ:</div>
                                        <div className="employee-value">{data.date_of_join || "-"}</div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="d-flex flex-column gap-2">
                                    <div>
                                        <div className="employee-label">Attendance Cycle::</div>
                                        <div className="employee-value">{data.attendance_cycle || "-"}</div>
                                    </div>
                                    <div className="employee-branch">
                                        <div className="employee-label">TDS Status::</div>
                                        <div className="employee-value">{data.tds_status || "-"}</div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

            </div>
        </Col> */}
    </Row>
}

export default Contact